<template>
    <div class="preparation-product">
        <div class="card">
            <div class="card-body">
                <div class="preparation-product-header">
                    <div class="preparation-product-ordered">
                        {{ counters.nb_ordered }}
                    </div>

                    <div class="preparation-product-name">
                        {{ name }}
                    </div>
                </div>

                <div class="preparation-product-inputs mb-2">
                    Quantité fabriquée non comptabilisée
                </div>

                <div class="preparation-product-footer">
                    <div class="dropdown float-right">
                        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fad fa-list"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <button class="dropdown-item" @click="$refs.modalChangeQuantity.showModal()">
                                <i class="fad fa-fw fa-user-lock"></i> Modifier la quantité commandée
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <ChangeNbProductsOrderedModal
                ref="modalChangeQuantity"
                :product-sku="sku"
                :product-name="name"
                :initial-quantity="counters.nb_ordered"
                :order="order"
            />
        </div>
    </div>
</template>

<script>
    import ChangeNbProductsOrderedModal from "../ChangeNbProductsOrderedModal";

    export default {
        name: 'PreparationProductPickupPoint',

        components: {
            ChangeNbProductsOrderedModal,
        },

        props: {
            order: {
                type: Object,
                required: true,
            },
            sku: {
                type: String,
                required: true,
            },
            name: {
                type: String,
                required: true,
            },
            preparationStatus: {
                type: Object,
                required: true,
            },
        },

        computed: {
            counters() {
                return this.preparationStatus.preparation_counters;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .preparation-product {
        .card-body {
            display: flex;
            flex-direction: column;
        }

        .preparation-product-header {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: baseline;
            font-size: 1.6rem;
            margin-bottom: 16px;

            .preparation-product-ordered, .preparation-product-prepared {
                border: 2px solid black;
                border-radius: 3px;
                min-height: 48px;
                min-width: 48px;
                line-height: 48px;
                text-align: center;
                flex-shrink: 0;
                padding: 0 7px;
            }

            .preparation-product-name {
                text-align: center;
                flex-shrink: 1;
                margin: 0 7px;
            }
        }

        .preparation-product-inputs {
            color: #cf2a27;
            font-weight: bold;
            text-align: center;
            flex-grow: 2;
        }
    }
</style>
